// extracted by mini-css-extract-plugin
export default {"date":"topDate_date__p95Ei"};